import React from "react";

const Divider = () => {
  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px 0",
    },
    image: {
      width: "auto",
      maxWidth: "100%",     // Ensures the image doesn't overflow
      height: "50px",       // Set height as per your preference
      objectFit: "contain", // Makes sure the image retains its aspect ratio
    },
  };

  return (
    <div style={styles.container}>
      <img
        src="Divider.png" // Replace with the correct path of your image
        alt="Divider"
        style={styles.image}
      />
    </div>
  );
};

export default Divider;
